import Vue from 'vue';

import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all';
import '@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2';
import '@fortawesome/fontawesome-free/webfonts/fa-solid-900.eot';
import '@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg';
import '@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf';
import '@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff';
import 'morioh/dist/css/morioh.min.css';
import '@morioh/v-lightbox/dist/lightbox.css';
import Lightbox from '@morioh/v-lightbox';

Vue.use(Lightbox);
